"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenu = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MenuMixin = require("../../mixins/components/MenuMixin");
var _Dropdown = require("../Dropdown/Dropdown");
var StyledMenu = /*#__PURE__*/(0, _styledComponents.default)(_Dropdown.Dropdown).withConfig({
  displayName: "StyledMenu",
  componentId: "c11n-8-107-0__sc-4596tk-0"
})(["", ""], _MenuMixin.MenuMixin);
exports.StyledMenu = StyledMenu;